import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { DmpLogo } from '../brand/DmpLogo';
import { PersonPhoto } from '../common/PersonPhoto';
import type { Driver } from '../../types/domain';
interface DriverQrCardProps {
  driver: Driver;
  vehicleReg: string;
  size?: 'md' | 'sm';
}
export function DriverQrCard({
  driver,
  vehicleReg,
  size = 'md'
}: DriverQrCardProps) {
  const sm = size === 'sm';
  return <div className={`overflow-hidden rounded-xl border-2 border-navy-800 bg-white shadow-sm ${sm ? 'w-[230px]' : 'w-[340px]'}`} data-id="element-2221" data-mp="1ka1wqg7uclv5">
      <div className={`flex items-center justify-between bg-navy-800 text-white ${sm ? 'px-2 py-1.5' : 'px-3 py-2'}`} data-id="element-2222" data-mp="1fbs0e2adrf7y">
        <div className="flex items-center gap-2" data-id="element-2223" data-mp="1t9gjp5osueaw">
          <DmpLogo size={sm ? 20 : 28} data-id="element-2224" data-mp="1pb94wgdwbn2c" />
          <p className={`font-semibold leading-tight ${sm ? 'text-[8px]' : 'text-[11px]'}`} data-id="element-2225" data-mp="1p83hd5kx0t8q">
            ঢাকা মেট্রোপলিটন পুলিশ
            <span className="block font-normal text-navy-200" data-id="element-2226" data-mp="3r1udttictv7l">অনুমোদিত চালক পরিচয়পত্র</span>
          </p>
        </div>
        <span className={`rounded bg-bdgreen-600 font-mono font-bold tracking-widest ${sm ? 'px-1 text-[8px]' : 'px-2 py-0.5 text-xs'}`} data-id="element-2227" data-mp="1eutshg6gojij">DRIVER</span>
      </div>
      <div className={`flex gap-3 ${sm ? 'p-2' : 'p-3'}`} data-id="element-2228" data-mp="1os85t6x38s6m">
        <PersonPhoto src={driver.photo} name={driver.name} size={sm ? 46 : 74} rounded="md" data-id="element-2229" data-mp="1oqnb9harx98r" />
        <div className="min-w-0 flex-1 space-y-0.5" data-id="element-2230" data-mp="1tjq6dtv78qr2">
          <p className={`font-bold text-navy-900 ${sm ? 'text-[10px]' : 'text-sm'}`} data-id="element-2231" data-mp="1yib85xq3nihm">{driver.name}</p>
          <p className={`font-mono text-slate-600 ${sm ? 'text-[8px]' : 'text-[11px]'}`} data-id="element-2232" data-mp="22jcz7r9v4o8i">{driver.license}</p>
          <p className={`text-slate-600 ${sm ? 'text-[8px]' : 'text-[11px]'}`} data-id="element-2233" data-mp="27i7s5m1jnt6c">সিএনজি: {vehicleReg}</p>
          <p className={`text-slate-600 ${sm ? 'text-[8px]' : 'text-[11px]'}`} data-id="element-2234" data-mp="2cic5x4b2i9sv">মেয়াদ: {driver.expiry}</p>
        </div>
        <div className="flex flex-col items-center" data-id="element-2235" data-mp="d5q6uk09n34c">
          <QRCodeSVG value={`https://verify.dmp.gov.bd/d/${driver.qrId}`} size={sm ? 48 : 78} level="M" fgColor="#081c3d" data-id="element-2236" data-mp="i3rsncp2tgji" />
          <p className={`mt-1 font-mono font-bold text-navy-900 ${sm ? 'text-[7px]' : 'text-[10px]'}`} data-id="element-2237" data-mp="a2k7jt75hm9d">{driver.qrId}</p>
        </div>
      </div>
      <div className="flex h-1.5" data-id="element-2238" data-mp="63bbuisjveb6">
        <span className="flex-1 bg-bdgreen-600" data-id="element-2239" data-mp="k0zwpqmmalg8" />
        <span className="w-6 bg-flagred" data-id="element-2240" data-mp="k2uit89mkjlw" />
        <span className="flex-1 bg-bdgreen-600" data-id="element-2241" data-mp="f26jlzb8swgl" />
      </div>
    </div>;
}